import { render, staticRenderFns } from "./VoucherReceiptShaqlawaView.vue?vue&type=template&id=018eabc3&"
import script from "./VoucherReceiptShaqlawaView.vue?vue&type=script&lang=js&"
export * from "./VoucherReceiptShaqlawaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports